import axios from "axios";
import money_bag from "assets/images/money_bag.svg";
import credit_card from "assets/images/credit_card.svg";
import coin from "assets/images/coin.svg";
import wealth from "assets/images/wealth.svg";
import star from "assets/images/star.svg";
import feature_1 from "assets/images/home_carousel/feature_1.png";
import feature_2 from "assets/images/home_carousel/feature_2.png";
import feature_3 from "assets/images/home_carousel/feature_3.png";
import { useEffect, useState } from "react";

const fetchPromotionsFromCMS = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_CMS_BASE_URL}/promotion-and-campaigns?sort=createdAt:desc&populate=*`,
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
        },
      }
    );

    return response.data.data;
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

export const fetchPromotions = async () => {
  try {
    const response = await axios.get(
      "https://www.alrajhibank.com.my/assets/json/promotions.json"
    );
    const cmsPromotions = await fetchPromotionsFromCMS();
    const jsonResponse = response.data;

    return [...cmsPromotions, ...jsonResponse].map((promotion) => ({
      title: promotion.title ? promotion.title : promotion.pageTitle,
      path: promotion.href || `/personal/promotions/${promotion.slug}`,
    }));
  } catch (error) {
    console.error("Error fetching promotions data", error);
    return [];
  }
};

export const useProductList = () => {
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    const fetchAndSetProductList = async () => {
      const promotionsContent = await fetchPromotions();

      const productList = [
        {
          id: 0,
          title: "Deposits",
          icon: money_bag,
          content: [
            {
              title: "Savings Account-<em>i</em>",
              path: "/personal/deposits/savings-account",
            },
            {
              title: "Current Account-<em>i</em>",
              path: "/personal/deposits/current-account",
            },
            {
              title: "Commodity Murabahah Term Deposit-<em>i</em>",
              path: "/personal/deposits/commodity-murabahah-td-i",
            },
            {
              title: "Commodity Murabahah Savings Account-<em>i</em>",
              path: "/personal/deposits/commodity-murabahah-sa-i",
            },
            {
              title: "Commodity Murabahah Current Account-<em>i</em>",
              path: "/personal/deposits/commodity-murabahah-ca-i",
            },
            {
              title:
                "Commodity Murabahah Foreign Currency<br/> Current Account-<em>i</em>",
              path: "/personal/deposits/commodity-murabahah-fc-ca-i",
            },
          ],
          image: feature_1,
        },
        {
          id: 1,
          title: "Cards",
          icon: credit_card,
          content: [
            {
              title: "alrajhi bank Malaysia Debit Card-<em>i</em>",
              path: "/personal/cards/debit-card",
            },
            {
              title: "alrajhi bank Malaysia Rafahia Card-<em>i</em>",
              path: "/personal/cards/rafahia-card",
            },
          ],
          image: feature_2,
        },
        {
          id: 2,
          title: "Financing",
          icon: coin,
          content: [
            {
              title: "Personal Financing-<em>i</em>",
              path: "/personal/financing/personal-financing-i",
            },
            {
              title: "Property Financing-<em>i</em>",
              path: "/personal/financing/home-financing-i",
            },
            {
              title: "Cashline-<em>i</em>",
              path: "/business/financing/cashline",
            },
          ],
          image: feature_3,
        },
        {
          id: 3,
          title: "Wealth Management",
          icon: wealth,
          content: [
            { title: "Gold-<em>i</em>", path: "/personal/wealth/gold-i" },
            {
              title: "GoldInvest-<em>i</em>",
              path: "/personal/wealth/gold-invest",
            },
            { title: "Unit Trust", path: "/personal/wealth/unit-trust" },
            {
              title: "Structured Product-<em>i</em>",
              path: "/personal/wealth/structured-product",
            },
            { title: "Will Writing", path: "/personal/wealth/will-writing" },
            {
              title: "Safe Deposit Box-<em>i</em>",
              path: "/personal/wealth/safe-deposit-box",
            },
            {
              title: "BancaTakaful - Sinar Kasih",
              path: "/personal/wealth/sinar-kasih",
            },
            {
              title: "BancaTakaful - Sinar Aiman",
              path: "/personal/wealth/sinar-link-aiman",
            },
          ],
          image: feature_1,
        },
        {
          id: 4,
          title: "Promotions",
          icon: star,
          content: promotionsContent,
          image: feature_2,
        },
      ];

      setProductList(productList);
    };

    fetchAndSetProductList();
  }, []);

  return productList;
};
